import * as types from '../actions/action-types';

const defaults = {
  loading: true,
  selected: {},
  list: []
};

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return {
    ...store,
    loading: false,
    list: data.slice()
  };
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SEARCH_DATA_RECEIVED:
      return setData(store, action.data);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/search-reducer.js